const UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

export function formatBytes(n: number): string {
  if (n === 0) return "0 B";
  const i = Math.min(
    Math.floor(Math.log(n) / Math.log(1024)),
    UNITS.length - 1,
  );
  const value = n / Math.pow(1024, i);
  const unit = UNITS[i] ?? "B";
  return `${Number.isInteger(value) ? value : value.toFixed(2)} ${unit}`;
}

export function formatDate(iso: string, locale = "ru-RU"): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(
    new Date(iso),
  );
}

export function daysUntil(iso: string): number {
  return Math.ceil(
    (new Date(iso).getTime() - Date.now()) / (1000 * 60 * 60 * 24),
  );
}

export function truncate(s: string, n: number): string {
  return s.length <= n ? s : s.slice(0, n) + "…";
}
